import React, { useState, useRef, useCallback } from 'react';
import Home from '../../Pages/Index';
import { Link } from 'react-router-dom';
import { useIsAuthenticated } from 'react-auth-kit';
import { ReactComponent as HomeIcon } from '../../assets/icons/home.svg';
import { ReactComponent as MenuIcon } from '../../assets/icons/menu.svg';
import CloseIcon from '@mui/icons-material/Close';

export default function Mobile(props) {
    const [open, setOpen] = useState(false);
    const isAuthenticated = useIsAuthenticated();

    function MobileNav(props) {
        if (!props.open) {
            return null;
        }

        if (isAuthenticated()) {
            return (
                <div className="Modal">
                    <div className="ModalBg">
                        <div className="mobileLinks">
                            <ul>
                                <li><a href="#" onClick={() => setOpen(false)}><CloseIcon style={{ fontSize: 40}} /></a></li>
                                
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/User/Profile">Profile</Link></li>
                                <li><Link to="/User/Logout">Logout</Link></li>
                                <li><Link to="/Admin">Admin</Link>
                                <ul>
                                        <li><Link to="/Admin/Users">Users</Link></li>
                                        <li><Link to="/Admin/Roles">Roles</Link></li>
                                        <li><Link to="/Admin/Appointments">Appointments</Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )
        } else {

            return (
                <React.Fragment>
                    <div className="Modal">
                        <div className="ModalBg">
                            <div className="mobileLinks">
                                <ul>
                                    <li><a href="#" onClick={() => setOpen(false)}><CloseIcon style={{ fontSize: 40, color: "white" }}/></a></li>
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/Login">Login</Link></li>
                                    <li><Link to="/Register">Register</Link></li>
                                    <li><Link to="/Map">Map</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }

    return (
        <React.Fragment>
            <nav className="mobileNav">
                <ul>
                    <li><Link to="/"><HomeIcon className="icon" /></Link></li>
                    <li><a href="#" onClick={() => setOpen(true)}><MenuIcon className="icon" /></a></li>
                </ul>
            </nav>
            <MobileNav open={open} />
        </React.Fragment>
    )
}